<div class="flex justify-center items-center h-screen">
  <mat-card appearance="outlined" class="sm:w-3/5 w-4/5">
    <div class="flex flex-col md:justify-between md:flex-row">
      <div class="w-full">
        <mat-card-header>
          <mat-card-title> Login </mat-card-title>
          <mat-card-subtitle>
            Enter the email address and password for your account.
          </mat-card-subtitle>
        </mat-card-header>

        <mat-card-content>
          <form [formGroup]="loginFormGroup" class="flex flex-col">
            <mat-progress-bar
              mode="indeterminate"
              *ngIf="loading"
              color="accent"
            ></mat-progress-bar>

            <mat-form-field>
              <mat-label>Email Address</mat-label>
              <input
                matInput
                type="email"
                formControlName="email"
                placeholder="Bizi@outlook.com"
              />
              <mat-icon matPrefix> person</mat-icon>

              @if (loginFormGroup.controls.email.hasError('email') &&
              !loginFormGroup.controls.email.hasError('required')) {
              <mat-error>Not a valid email address.</mat-error>
              } @if (loginFormGroup.controls.email.hasError('required')) {
              <mat-error>Email is required.</mat-error>
              }
            </mat-form-field>

            <mat-form-field>
              <mat-label>Password</mat-label>
              <input
                matInput
                [type]="hide() ? 'password' : 'text'"
                formControlName="password"
                placeholder="Password"
                (keydown.enter)="login()"
              />
              <button
                type="button"
                mat-icon-button
                matSuffix
                (click)="clickEvent($event)"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide()"
              >
                <mat-icon>{{
                  hide() ? "visibility_off" : "visibility"
                }}</mat-icon>
              </button>
              <mat-icon matPrefix> vpn_key</mat-icon>
              @if (loginFormGroup.controls.password.hasError('required')) {
              <mat-error>Password is required.</mat-error>
              } @if (loginFormGroup.controls.password.touched &&
              loginFormGroup.get('password')?.hasError('whitespace')) {
              <mat-error>Password cannot be only whitespace.</mat-error>
              }
            </mat-form-field>
          </form>
        </mat-card-content>

        <mat-card-actions>
          <button
            mat-raised-button
            [disabled]="loginFormGroup.invalid"
            (click)="login()"
            class="w-full"
            color="accent"
          >
            Login
          </button>
        </mat-card-actions>

        <mat-card-footer>
          <button mat-flat-button routerLink="/forgot-password">
            Forgot Password
          </button>
        </mat-card-footer>
      </div>
      <div class="w-1/2 lg:w-1/3 flex self-center">
        <img
          src="assets\Circle Logo - White Background.png"
          class="self-center"
        />
      </div>
    </div>
  </mat-card>
</div>
